const SENSOR_CONFIG = {
  // Sensor thresholds by type
  temperature: {
    MIN_THRESHOLD_CONFIG: -55,
    MAX_THRESHOLD_CONFIG: 125,
  },
};

module.exports = SENSOR_CONFIG;
